// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';
import { PersonRef } from './personRef.zod.ts';

export const industryOutIdeaCountDefault = 0;

export const IndustryOut = zod.object({
  "created_at": zod.iso.datetime({"offset":true}),
  "description": zod.union([zod.string(),zod.null()]),
  "id": zod.uuid(),
  "idea_count": zod.int().default(industryOutIdeaCountDefault),
  "is_active": zod.boolean(),
  "name": zod.string(),
  "reviewed_at": zod.union([zod.iso.datetime({"offset":true}),zod.null()]).optional(),
  "reviewed_by": zod.union([PersonRef,zod.null()]).optional(),
  "status": zod.enum(['approved', 'pending']),
  "suggested_by": zod.union([PersonRef,zod.null()]).optional()
});

export type IndustryOut = zod.input<typeof IndustryOut>;
export type IndustryOutOutput = zod.output<typeof IndustryOut>;
